(function() {
'use strict';

angular
    .module('TR')
    .service('recentHotels', recentHotels);

function recentHotels($http, hotelRehydrator, $window, $timeout, $rootScope, broker) {
    const url = '/api2/recentlyviewedhotels/';
    const defer =
        $window.requestAnimationFrame ||
        $window.webkitRequestAnimationFrame ||
        $timeout;

    let promise;

    $rootScope.$on('auth:signout', _clearPromise);
    $rootScope.$on('auth:signin', _clearPromise);

    const service = {
        set,
        remove,
        clear,
        get,
        getIds
    };

    function _clearPromise() {
        promise = null;
        broker.publish('recentHotelsModified');
    }

    function set(estabId) {
        if (estabId > 0 && TRPCONFIG.Domain2.GetReviewedHotelsAPI) {
            defer(function() {
                return $http
                    .post(`${url}set`, { EstabId: estabId }, { ignoreErrors: true })
                    .then(_clearPromise)
                    .then(() => broker.publish('recentHotelAdded', estabId));
            });
        }
    }

    function remove(estabId) {
        if (estabId > 0 && TRPCONFIG.Domain2.GetReviewedHotelsAPI) {
            return $http
                .post(`${url}remove`, { EstabId: estabId })
                .then(_clearPromise)
                .then(() => broker.publish('recentHotelRemoved', estabId));
        }
    }

    function clear() {
        return $http.post(`${url}removeall`)
            .then(_clearPromise);
    }

    function get() {
        return promise = promise || $http
            .get(`${url}get`, { ignoreErrors: true })
            .then(results => hotelRehydrator.hotels(results.data));
    }

    function getIds() {
        return $http
            .get(`${url}get`, { ignoreErrors: true })
            .then(results => results.data);
    }

    if (TRPCONFIG.Domain2.GetReviewedHotelsAPI) {
        return service;
    }
}
})();
